import {
    GetItemCounts,
} from "@twigsby/client-data";
import {useInfiniteSendMailBox} from "@twigsby/client-data/lib/Wrappers/ReactQuery/Endpoints/SendMail";
import {
    PageHeader, ContentBlock,
    ContentLoader,
    FullWidthSidebar,
    InfiniteLoadTrigger, ItemRowHeader,
    useLayout
} from "@twigsby/frontend-framework";
import React, {useEffect, useRef, useState} from "react";
import {useTranslation} from "@twigsby/frontend-framework";
import SendsNavigation from "../../Components/SendMail/Shared/Controls/SendsNavigation";
import SendsHistoryItem from "../../Components/SendsAdmin/SendsHistoryItem";
import {useSite} from "../../Providers/SiteInterfaceProvider";

const SendMail = () => {
    const{ t } = useTranslation();
    const { isSmall, isMedium, isLarge } = useLayout();
    const { currentLocale, updatePageMeta } = useSite();

    const [itemCounts, setItemCounts] = useState<any>({ loaded: 0, total: 0 } );

    const {
        status,
        data,
        error,
        isFetchingNextPage,
        fetchNextPage,
        hasNextPage,
        dataUpdatedAt
    } = useInfiniteSendMailBox();

    const sendMailRef = useRef<any>();
    const sendMailNavigationRef = useRef<any>();

    useEffect(() => {
        if(data) {
            setItemCounts(GetItemCounts(data as any));
        }
    }, [dataUpdatedAt, data]);


    useEffect(() => {
        updatePageMeta({
            title: t('sends.history.title')
        });
    }, [currentLocale]);

    return (
        <>
            <FullWidthSidebar
                ref={sendMailRef}
                navigationComponent={

                    <SendsNavigation
                        ref={sendMailNavigationRef}
                        title={t('sends.history.title')}
/*                        addonContent={
                            <>
                                {!isLarge && (
                                    <>
                                        <div className={'section-navigation-header-collapsed-addon'}>
                                            <SendHistoryFilterButton />
                                        </div>
                                        <SendsHistoryFilterControl />
                                    </>
                                )}
                            </>
                        }*/

                    />
                }
                extraContentClass={`flex-column sends-single-history-rows`}
            >
                {isLarge && (
                    <PageHeader title={t('sends.history.title')} />
                )}

                {isSmall && (
                    <ItemRowHeader sticky={true} extraClass={'pl-lg'}>
                        <div>{t('sends.history.headings.file')}</div>
                        <div>{t('sends.history.headings.sentId')}</div>
                        <div>{t('sends.history.headings.address')}</div>
                        <div>{t('sends.history.headings.postage')}</div>
                        <div>{t('sends.history.headings.date')}</div>
                    </ItemRowHeader>
                )}

                <>
                    {status === "loading" ? (
                        <ContentLoader childHeight={'7em'}/>
                    ) : status === "error" ? (
                        <ContentBlock error={true} title={error.name} content={error.message} />
                    ) : (
                        <>
                            {data.pages.map((group, groupIndex) =>
                                group.data.map((sentItem: any, index) =>
                                    <SendsHistoryItem hideUserDetails={true}
                                        id={sentItem.mailUuid}
                                        title={sentItem.itemReference}
                                        liveUrl={`/mail/sends/${sentItem.mailUuid}`}
                                        user={{
                                            id: '1',
                                            name: 'name',
                                            emailAddress: 'email'
                                        }}
                                        dateCreated={sentItem.dateUploaded}
                                        isDeleted={false}
                                        mailItem={{
                                            mailUuid: sentItem.mailUuid,
                                            trackingId: sentItem.itemReference,
                                            dateReceived: sentItem.dateUploaded,
                                            dateRead: sentItem.dateUploaded,
                                            dateUpdated: sentItem.dateUpdated,
                                            mailAction: {
                                                key: 'string',
                                                description: 'string',
                                                status: 'string',
                                                requiresUserInput: false
                                            },
                                            mailType: 1,
                                            files: sentItem.files,
                                            daysUntilNextStorageCharge: null,
                                            orderByDate: sentItem.dateUpdated,
                                            actions: []
                                        }}
                                        postageOption={{
                                            id: sentItem.postageOption.id,
                                            name: sentItem.postageOption.optionName
                                        }}
                                        address={sentItem.clientAddress}
                                    />
                                )
                            )}

                            <InfiniteLoadTrigger
                                loaded={itemCounts.loaded}
                                totalCount={itemCounts.total}
                                hasNextPage={hasNextPage}
                                fetchNextPage={fetchNextPage}
                                isFetchingNextPage={isFetchingNextPage}
                            />
                        </>
                    )}
                </>
            </FullWidthSidebar>

        </>
    );
};

export default SendMail;
